import * as React from 'react';
import * as s from './tooltip.scss';
import { IClickableButton } from '../../../types/assistant';
import { ArrowPosition } from '../../../types/assistant-actions';

export const TOUR_TOOLTIP_ARROW_WRAPPER_ID = 'tour-tooltip-arrow-wrapper';
export const TOUR_TOOLTIP_WRAPPER_ID = 'tour-tooltip-wrapper';

export interface TourTooltipWrapperProps
  extends TourTooltipProps,
    TourTooltipArrowProps {
  show: boolean;
  component: React.ComponentType<TourTooltipProps>;
  arrowComponent: React.ComponentType<TourTooltipArrowProps>;
  style?: { [key: string]: string | number };
  zIndex?: number;
}

export interface TourTooltipProps {
  content: string;
  title?: string;
  activeActionIndex?: number;
  buttons?: IClickableButton[];
  showCloseButton?: boolean;
  stopTourFn?(): void;
  successMessage?: boolean;
  customProps: { [key: string]: any };
}

export interface TourTooltipArrowProps {
  arrowPosition: ArrowPosition;
}

export class TourTooltipWrapper extends React.Component<
  TourTooltipWrapperProps,
  any
> {
  get propsForTooltip() {
    return {
      title: this.props.title,
      content: this.props.content,
      activeActionIndex: this.props.activeActionIndex,
      stopTourFn: this.props.stopTourFn,
      buttons: this.props.buttons,
      showCloseButton: this.props.showCloseButton,
      successMessage: this.props.successMessage,
      customProps: this.props.customProps,
    };
  }

  get styleOfArrow(): { [key: string]: string | number } {
    return this.props.style && this.props.style.zIndex
      ? { zIndex: this.props.style.zIndex }
      : {};
  }

  renderTooltip() {
    return React.createElement(this.props.component, this.propsForTooltip);
  }

  renderArrow() {
    return React.createElement(this.props.arrowComponent, {
      arrowPosition: this.props.arrowPosition,
    });
  }

  render() {
    return (
      <>
        <div
          id={TOUR_TOOLTIP_WRAPPER_ID}
          className={s.tourTooltipWrapper}
          style={this.props.style}
        >
          {this.props.show && this.renderTooltip()}
        </div>
        <div
          id={TOUR_TOOLTIP_ARROW_WRAPPER_ID}
          className={`${s.tourTooltipWrapper}`}
          style={this.styleOfArrow}
        >
          {this.props.show && this.renderArrow()}
        </div>
      </>
    );
  }
}
